module.exports = __webpack_public_path__ + "media/images/video-img-3c03d8a59f3b665dc66877de6f97c109.jpg";